import React from "react";
import S from './Information.module.scss';

export const Information = () => {
  return (
    <div className={S.root} id='information'>
      <div className={S.elements}>
        <h1 className={S.title}>Наш подход - эффективная<br/><span>цифровизация</span> на основе <span>low-code</span></h1>
        <div className={S.groupParagraph}>
          <div className={S.boxParagraphUp}>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>1</div>
              <div className={S.paragraphText}>гибкая адаптация под<br/> бизнес-процессы компании</div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>2</div>
              <div className={S.paragraphText}>единый контур: веб-интерфейс<br/> и мобильное приложение</div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>3</div>
              <div className={S.paragraphText}>быстрая разработка и<br/> запуск решений</div>
            </div>
          </div>
          <div className={S.boxParagraphBottom}>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>4</div>
              <div className={S.paragraphText}>модульная архитектура и бесшовное обновление<br/> системы без остановки
                процессов
              </div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>5</div>
              <div className={S.paragraphText}>высокая производительность при<br/> обработке больших объемов данных
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};